import Vue from 'vue'
import Vuex from 'vuex'
import http from '@/http'
import auth from '@/store/modules/auth'
import account from '@/store/modules/account'
import licensePlan from '@/store/modules/licensePlan'
import reservedRoom from '@/store/modules/reservedRoom'
import licensePlanMasters from '@/store/modules/licensePlanMasters'
import roomOptionMasters from '@/store/modules/roomOptionMasters'
import whiteboard from '@/store/modules/whiteboard'
import note from '@/store/modules/note'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    httpSuccess: false,
    httpError: false,
    httpRequesting: false
  },
  getters: {
    httpSuccess: state => state.httpSuccess,
    httpError: state => state.httpError,
    httpRequesting: state => state.httpRequesting
  },
  mutations: {
    setHttpSuccess (state, payload) {
      state.httpSuccess = payload
    },
    setHttpError (state, payload) {
      state.httpError = payload
    },
    setHttpRequesting (state, payload) {
      state.httpRequesting = payload
    }
  },
  actions: {
    clearHttpStatus({ commit }) {
      commit('setHttpSuccess', false)
      commit('setHttpError', false)
    },
    request({ commit }) {
      commit('setHttpSuccess', false)
      commit('setHttpError', false)
      commit('setHttpRequesting', true)
    },
    response({ commit }) {
      commit('setHttpRequesting', false)
    },
    async postContact({ commit }, payload) {
      await http.post('contact', payload).then(() => {
        commit('setHttpSuccess', 'お問い合わせを送信しました。')
      }).catch(error => {
        commit('setHttpError', error)
      })
    }
  },
  modules: {
    auth,
    account,
    licensePlan,
    reservedRoom,
    licensePlanMasters,
    roomOptionMasters,
    whiteboard,
    note
  }
})
